import type { PrimitiveDef, SubstrateManifest, TierLabel } from '../manifest';

function groupPrimitives(manifest: SubstrateManifest): Array<{ tier: TierLabel; primitives: PrimitiveDef[] }> {
  return manifest.tier_labels
    .map((tier) => ({
      tier,
      primitives: manifest.primitives.filter((primitive) => primitive.tier === tier.id),
    }))
    .filter((group) => group.primitives.length > 0);
}

export function PrimitivePalette({
  manifest,
  onAddPrimitive,
}: {
  manifest: SubstrateManifest;
  onAddPrimitive?: (primitive: PrimitiveDef) => void;
}) {
  const groups = groupPrimitives(manifest);

  return (
    <aside className="sp-widget" style={{ minHeight: 0 }}>
      <div className="sp-widget-header">
        <span>Primitive Palette</span>
        <span className="mono">{manifest.primitives.length} items</span>
      </div>
      <div className="sp-widget-body" style={{ display: 'grid', gap: 12 }}>
        {groups.map(({ tier, primitives }) => (
          <section key={tier.id}>
            <div
              className="mono"
              style={{
                color: tier.color,
                fontSize: 11,
                fontWeight: 700,
                letterSpacing: '0.08em',
                marginBottom: 6,
                textTransform: 'uppercase',
              }}
            >
              {tier.label}
            </div>
            <div style={{ display: 'grid', gap: 6 }}>
              {primitives.map((primitive) => (
                <article
                  key={primitive.id}
                  style={{
                    background: 'var(--sp-bg)',
                    border: `1px solid ${tier.color}55`,
                    borderLeft: `3px solid ${tier.color}`,
                    borderRadius: 'var(--sp-radius)',
                    padding: 10,
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
                    <strong style={{ color: 'var(--sp-text)', fontSize: 13 }}>{primitive.label}</strong>
                    <span className="mono" style={{ color: 'var(--sp-text-dim)', fontSize: 10 }}>
                      {primitive.capability_class}
                    </span>
                  </div>
                  <p style={{ color: 'var(--sp-text-muted)', fontSize: 12, margin: '6px 0 0' }}>
                    {primitive.description}
                  </p>
                  <code style={{ color: 'var(--sp-text-dim)', display: 'block', fontSize: 11, marginTop: 6 }}>
                    {primitive.id}
                  </code>
                  {onAddPrimitive ? (
                    <button
                      className="sp-btn"
                      onClick={() => onAddPrimitive(primitive)}
                      style={{ marginTop: 8, padding: '4px 8px' }}
                      type="button"
                    >
                      Add to graph
                    </button>
                  ) : null}
                </article>
              ))}
            </div>
          </section>
        ))}
      </div>
    </aside>
  );
}
